module.exports = __webpack_public_path__ + "img/ES-J-18.4fee616b.svg";